<div class="list-wrapper">
    <div class="container">
        <div class="header-container">
            <div>{{ 'mimics.settings.alarm-indicator.title' | translate }}</div>
            <div class="edit-channels" (click)="openChannelsPage()">
                {{ 'mimics.settings.alarm-indicator.edit-channels' | translate }}
            </div>
        </div>
        <div class="alarm-colors-container" *ngIf="showAnalogLevels">
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.high-high'"
                [color]="getAlarmColor(fcuData.alarmSettingVeryHigh.alarmLevel)"
                [alarmLevel]="getAlarmLevel(fcuData.alarmSettingVeryHigh.alarmLevel)"
                [enabled]="fcuData.alarmSettingVeryHigh.enable">
            </app-alarm-color-indicator>
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.high'"
                [color]="getAlarmColor(fcuData.alarmSettingHigh.alarmLevel)"
                [alarmLevel]="getAlarmLevel(fcuData.alarmSettingHigh.alarmLevel)"
                [enabled]="fcuData.alarmSettingHigh.enable">
            </app-alarm-color-indicator>
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.low'"
                [color]="getAlarmColor(fcuData.alarmSettingLow.alarmLevel)"
                [alarmLevel]="getAlarmLevel(fcuData.alarmSettingLow.alarmLevel)"
                [enabled]="fcuData.alarmSettingLow.enable">
            </app-alarm-color-indicator>
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.low-low'"
                [color]="getAlarmColor(fcuData.alarmSettingVeryLow.alarmLevel)"
                [alarmLevel]="getAlarmLevel(fcuData.alarmSettingVeryLow.alarmLevel)"
                [enabled]="fcuData.alarmSettingVeryLow.enable">
            </app-alarm-color-indicator>
        </div>
        <div class="alarm-colors-container" *ngIf="isMotorElement">
            <app-alarm-color-indicator
                [title]="'channel.label.alarm'"
                [color]="getAlarmColor(fcuData?.digitalAlarmSetting?.alarmLevel)"
                [enabled]="fcuData?.digitalAlarmSetting?.enable">
            </app-alarm-color-indicator>
        </div>
    </div>

    <div class="container" *ngIf="showSensorFailureLevels">
        <div class="alarm-colors-container">
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.sensor-fail'"
                [color]="getAlarmColor(fcuData.alarmSettingSensorFail.alarmLevel, 'Sensor failure')"
                [alarmLevel]="getAlarmLevel(fcuData.alarmSettingSensorFail.alarmLevel)"
                [enabled]="fcuData.alarmSettingSensorFail.enable">
            </app-alarm-color-indicator>
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.fu-unresponsive'"
                [color]="getAlarmColor(fcuData.alarmSettingSensorFail.alarmLevel, 'FU unresponsive')"
                [alarmLevel]="getAlarmLevel(fcuData.alarmSettingSensorFail.alarmLevel)"
                [enabled]="fcuData.alarmSettingSensorFail.enable">
            </app-alarm-color-indicator>
        </div>
    </div>

    <div class="container" *ngIf="showFeedbackLevels && !isMotorElement">
        <div class="alarm-colors-container">
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.feedback'"
                [color]="getAlarmColor(fcuData.alarmSettingFeedbackError.alarmLevel)"
                [alarmLevel]="getAlarmLevel(fcuData.alarmSettingFeedbackError.alarmLevel)"
                [enabled]="fcuData.alarmSettingFeedbackError.enable">
            </app-alarm-color-indicator>
        </div>
    </div>

    <div class="container" *ngIf="showDigitalLevels && !isMotorElement">
        <div class="alarm-colors-container">
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.digital.status'"
                [status]="fcuData.digitalAlarmSetting.statusStringContactOn"
                [color]="getAlarmColor(fcuData.digitalAlarmSetting.alarmLevel, 'Digital on')"
                [alarmLevel]="getAlarmLevel(fcuData.digitalAlarmSetting.alarmLevel)"
                [enabled]="fcuData.digitalAlarmSetting.enable">
            </app-alarm-color-indicator>
            <app-alarm-color-indicator
                [title]="'channel.label.alarm.digital.status'"
                [status]="fcuData.digitalAlarmSetting.statusStringContactOff"
                [color]="getAlarmColor(fcuData.digitalAlarmSetting.alarmLevel, 'Digital off')"
                [alarmLevel]="getAlarmLevel(fcuData.digitalAlarmSetting.alarmLevel)"
                [enabled]="fcuData.digitalAlarmSetting.enable">
            </app-alarm-color-indicator>
        </div>
    </div>

    <div class="container" *ngIf="showFeedbackLevels || isMotorElement">
        <div class="header-container" *ngIf="isMotorElement">
            <div>{{ 'mimic.setting.motor-setting.status.title' | translate }}</div>
        </div>
        <div class="alarm-colors-container">
            <ng-container *ngIf="fcuData.motorChannelSetting?.stopStatusString || isMotorElement">
                <app-alarm-color-indicator
                    [title]="
                        isMotorElement
                            ? 'mimic.setting.motor-setting.status.stop'
                            : 'channel.label.alarm.digital.status'
                    "
                    [status]="isMotorElement ? null : fcuData.motorChannelSetting?.stopStatusString"
                    [color]="getAlarmColor(fcuData.motorChannelSetting?.alarmLevel, 'Motor stop')"
                    [alarmLevel]="getAlarmLevel(fcuData.motorChannelSetting?.alarmLevel)"
                    [enabled]="isMotorElement || fcuData.motorChannelSetting?.enable">
                </app-alarm-color-indicator>
            </ng-container>

            <ng-container *ngIf="!isMotorElement && fcuData.motorChannelSetting.stbyStatusString">
                <app-alarm-color-indicator
                    [title]="'channel.label.alarm.digital.status'"
                    [status]="fcuData.motorChannelSetting.stbyStatusString"
                    [color]="getAlarmColor(fcuData.motorChannelSetting.alarmLevel, 'Motor standby')"
                    [alarmLevel]="getAlarmLevel(fcuData.motorChannelSetting.alarmLevel)"
                    [enabled]="fcuData.motorChannelSetting.enable">
                </app-alarm-color-indicator>
            </ng-container>

            <app-alarm-color-indicator
                [title]="
                    isMotorElement ? 'mimic.setting.motor-setting.status.running' : 'channel.label.alarm.digital.run'
                "
                [color]="getAlarmColor(fcuData.motorChannelSetting?.alarmLevel, 'Motor running')"
                [alarmLevel]="getAlarmLevel(fcuData.motorChannelSetting?.alarmLevel)"
                [enabled]="isMotorElement || fcuData.motorChannelSetting?.enable">
            </app-alarm-color-indicator>
        </div>
    </div>
</div>
